import { Injectable } from '@angular/core';
import { SyskaServicePkg } from './syskaPkg.service';

export const syska006List = [{ id: "0", name: "等待中" }, { id: "1", name: "進行中" }, { id: "5", name: "失敗" }, { id: "9", name: "完成" }]; // 處理進度
export const syska008List = [{ id: "批次", name: "批次" }, { id: "報表", name: "批次" }, { id: "api", name: "API批次" }]; // 分類
export const syska019List = [{ id: "", name: "不通知" }, { id: "1", name: "有錯誤通知" }, { id: "2", name: "有錯誤或警告通知" }, { id: "3", name: "完成就通知" }]; // MAIL通知方式

@Injectable({
  providedIn: 'root',
})
export class SyskaService extends SyskaServicePkg {
  syska006List = syska006List;
  syska008List = syska008List;
  syska019List = syska019List;
  constructor() {
    super();
  }
}
